import { useUserStore } from '../stores/userStore'

export const vRole = {
  mounted(el, binding) {
    const userStore = useUserStore()
    
    // Handle both single role and array of roles
    const requiredRoles = Array.isArray(binding.value) ? binding.value : [binding.value]
    
    // Check if user has any of the required roles
    const hasRequiredRole = requiredRoles.some(role => userStore.hasRole(role))
    
    // If user doesn't have required role, hide the element
    if (!hasRequiredRole) {
      el.style.display = 'none'
    }
  },
  updated(el, binding) {
    const userStore = useUserStore()
    const requiredRoles = Array.isArray(binding.value) ? binding.value : [binding.value]
    const hasRequiredRole = requiredRoles.some(role => userStore.hasRole(role))
    
    el.style.display = hasRequiredRole ? '' : 'none'
  }
}

// Usage example:
// <button v-role="'admin'">Admin Only</button>
// <div v-role="['admin', 'manager']">Admin or Manager</div>
